var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"d-flex align-items-center bg-white shadow-sm shadow-blue mr-2",attrs:{"pill":"","variant":"light","size":"sm"},on:{"click":_vm.sendCredits}},[_c('span',{staticClass:"text-primary"},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"fa-duotone fa-coin"}})],1),_vm._v(" "+_vm._s(_vm.$t("Send"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }